// P2.2 copy: booking wizard, service-area map, Google reviews, footer city list (5 languages).
const COPY = {
  de: {
    booking: {
      eyebrow: "Anfrage & Termin", title: "Ihr Service. Konfiguriert in einer Minute.",
      subtitle: "Wählen Sie Leistung, Ort und Wunschtermin — wir melden uns mit einem persönlichen Angebot.",
      response: "Wir antworten in der Regel innerhalb von 1 Stunde.",
      steps: ["Leistung", "Ort", "Termin", "Angaben", "Prüfen"],
      stepTitles: ["Welche Leistung wünschen Sie?", "Wo dürfen wir zu Ihnen kommen?", "Wann passt es Ihnen?", "Wie erreichen wir Sie?", "Ihre Anfrage im Überblick"],
      services: {
        interior: { title: "Innenaufbereitung", desc: "Sitze, Teppiche, Kunststoffe, Scheiben" },
        exterior: { title: "Außenaufbereitung", desc: "Handwäsche, Felgen, Lackpflege" },
        complete: { title: "Komplettaufbereitung", desc: "Innen und außen in einem Termin" },
        sofa: { title: "Sofa- & Polsterreinigung", desc: "Sofas, Sessel, Matratzen bei Ihnen zu Hause" },
        other: { title: "Andere / individuelle Anfrage", desc: "Beschreiben Sie uns Ihr Anliegen" },
      },
      location: {
        search: "Ort suchen …", core: "Kerngebiet", extended: "Erweitertes Gebiet",
        extendedNote: "Termine im erweiterten Gebiet nach individueller Absprache.",
        other: "Anderer Ort", otherPlaceholder: "Ort oder PLZ eingeben", noResults: "Kein Ort gefunden — geben Sie ihn unten manuell ein.",
      },
      appointment: {
        modes: {
          date: { title: "Wunschdatum", desc: "Datum und Zeitfenster wählen" },
          flexible: { title: "Ich bin flexibel", desc: "Wir schlagen Ihnen Termine vor" },
          earliest: { title: "Frühestmöglich", desc: "Nächster freier Termin" },
        },
        windowLabel: "Bevorzugtes Zeitfenster", anyTime: "Egal",
        windows: { "08-11": "Morgens", "11-14": "Mittags", "14-17": "Nachmittags", "17-20": "Abends" },
        notice: "Ihr Wunschtermin ist noch keine Terminbestätigung. Wir bestätigen den Termin persönlich.",
      },
      details: {
        name: "Name", phone: "Telefon / WhatsApp", email: "E-Mail", optional: "optional",
        vehicle: "Fahrzeugmodell", furniture: "Möbelart", object: "Objekt", objectPlaceholderCar: "z. B. BMW X5, 2021", objectPlaceholderSofa: "z. B. 3-Sitzer-Sofa, Stoff",
        notes: "Details", notesPlaceholder: "Zustand, besondere Wünsche, Parkmöglichkeit …",
        photos: "Fotos hinzufügen", photosHint: "Optional, bis zu 5 Bilder. Fotos werden sicher über unser Formular übertragen.",
        contact: "Bevorzugter Kontakt", contacts: { WhatsApp: "WhatsApp", Telefon: "Anruf", Email: "E-Mail" },
      },
      review: {
        service: "Leistung", location: "Ort", appointment: "Wunschtermin", contact: "Kontakt", edit: "Ändern",
        consent: "Ich stimme der Verarbeitung meiner Angaben zur Bearbeitung meiner Anfrage zu.",
        primary: "Über WhatsApp senden", secondary: "Ohne WhatsApp absenden",
        hint: "Ihre Anfrage wird gespeichert und WhatsApp öffnet sich mit einer vorbereiteten Nachricht. Bitte tippen Sie dort auf „Senden“.",
        photosNote: "Fotos werden über das Formular übermittelt und nicht automatisch an WhatsApp angehängt.",
      },
      nav: { back: "Zurück", next: "Weiter", saving: "Wird gespeichert …" },
      errors: {
        service: "Bitte wählen Sie eine Leistung.", location: "Bitte wählen oder geben Sie einen Ort ein.",
        date: "Bitte wählen Sie ein Wunschdatum.", name: "Bitte geben Sie Ihren Namen ein.",
        phone: "Bitte geben Sie eine gültige Telefonnummer ein.", email: "Bitte prüfen Sie die E-Mail-Adresse.",
        emailRequired: "Für Kontakt per E-Mail benötigen wir Ihre E-Mail-Adresse.", consent: "Bitte bestätigen Sie die Einwilligung.",
        submit: "Senden fehlgeschlagen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt auf WhatsApp.",
        photos: "Maximal 5 Fotos.",
      },
      done: {
        titleWa: "Fast geschafft — bitte in WhatsApp senden.",
        textWa: "Ihre Anfrage ist bei uns gespeichert. WhatsApp wurde mit einer vorbereiteten Nachricht geöffnet — die Nachricht wird erst zugestellt, wenn Sie dort auf „Senden“ tippen.",
        titleForm: "Vielen Dank — Ihre Anfrage ist eingegangen.",
        textForm: "Wir melden uns auf dem gewünschten Weg bei Ihnen.",
        reference: "Referenz", reopen: "WhatsApp erneut öffnen", newRequest: "Neue Anfrage",
      },
      wa: {
        greeting: "Hallo PUREGLOSS, ich habe eine Anfrage über die Website gestellt:", service: "Leistung", location: "Ort",
        appointment: "Wunschtermin", name: "Name", phone: "Telefon", email: "E-Mail", object: "Objekt", details: "Details",
        photos: (n) => `${n} Foto(s) über das Formular hochgeladen`, contact: "Bevorzugter Kontakt", ref: "Referenz",
      },
      liveSlots: "Lieber direkt einen freien Termin im Kalender wählen?", backToWizard: "Zurück zur Anfrage",
    },
    map: {
      eyebrow: "Einsatzgebiet", title: "Wir kommen zu Ihnen.",
      subtitle: "Premium Fahrzeugaufbereitung und Polsterreinigung — mobil bei Ihnen vor Ort.",
      base: "Unser Standort", core: "Kerngebiet", extended: "Erweitertes Gebiet · nach Absprache",
      request: "Preis anfragen", list: "Alle Orte als Liste", hideList: "Liste ausblenden", loading: "Karte wird geladen …",
      select: "Ort auswählen",
    },
    area: {
      short: "Kerngebiet Euskirchen · Köln · Bonn mit Umgebung. Dazu Düren und Umgebung. Nach Absprache auch Eifel, Düsseldorf/Neuss, Bergisches Land und Ruhrgebiet.",
      footerTitle: "Alle Einsatzorte", search: "Ort suchen", showAll: "Alle Orte anzeigen", hide: "Weniger anzeigen",
    },
    reviews: {
      title: "Was unsere Kunden sagen.", text: "Echte Bewertungen aus unserem Google-Unternehmensprofil.",
      fallback: "Lesen Sie unabhängige Bewertungen unserer Kunden direkt auf Google.", cta: "Alle Bewertungen auf Google",
      prev: "Vorherige Bewertung", next: "Nächste Bewertung", source: "Bewertungen von Google", count: "Bewertungen",
      original: "Auf Google ansehen",
    },
    academyConcept: "Symbolbild · KI-generiert",
  },
  ua: {
    booking: {
      eyebrow: "Запит і запис", title: "Ваш сервіс. Налаштовано за хвилину.",
      subtitle: "Оберіть послугу, місце та бажаний час — ми надішлемо персональну пропозицію.",
      response: "Зазвичай ми відповідаємо протягом 1 години.",
      steps: ["Послуга", "Місце", "Час", "Дані", "Перевірка"],
      stepTitles: ["Яка послуга вас цікавить?", "Куди нам приїхати?", "Коли вам зручно?", "Як з вами зв'язатися?", "Ваш запит коротко"],
      services: {
        interior: { title: "Хімчистка салону", desc: "Сидіння, килимки, пластик, скло" },
        exterior: { title: "Догляд за кузовом", desc: "Ручна мийка, диски, догляд за лаком" },
        complete: { title: "Комплексний детейлінг", desc: "Салон і кузов за один візит" },
        sofa: { title: "Хімчистка диванів і меблів", desc: "Дивани, крісла, матраци у вас вдома" },
        other: { title: "Інше / індивідуальний запит", desc: "Опишіть, що вам потрібно" },
      },
      location: {
        search: "Пошук міста …", core: "Основна зона", extended: "Розширена зона",
        extendedNote: "Виїзд у розширену зону — за індивідуальною домовленістю.",
        other: "Інше місце", otherPlaceholder: "Місто або поштовий індекс", noResults: "Місто не знайдено — введіть його нижче вручну.",
      },
      appointment: {
        modes: {
          date: { title: "Бажана дата", desc: "Оберіть дату й часовий проміжок" },
          flexible: { title: "Я гнучкий", desc: "Ми запропонуємо варіанти" },
          earliest: { title: "Якнайшвидше", desc: "Найближчий вільний термін" },
        },
        windowLabel: "Бажаний час", anyTime: "Будь-коли",
        windows: { "08-11": "Ранок", "11-14": "Обід", "14-17": "День", "17-20": "Вечір" },
        notice: "Бажаний час ще не є підтвердженим записом. Ми підтвердимо термін особисто.",
      },
      details: {
        name: "Ім'я", phone: "Телефон / WhatsApp", email: "E-mail", optional: "необов'язково",
        vehicle: "Модель авто", furniture: "Тип меблів", object: "Об'єкт", objectPlaceholderCar: "напр. BMW X5, 2021", objectPlaceholderSofa: "напр. 3-місний диван, тканина",
        notes: "Деталі", notesPlaceholder: "Стан, побажання, можливість паркування …",
        photos: "Додати фото", photosHint: "Необов'язково, до 5 фото. Фото безпечно передаються через нашу форму.",
        contact: "Зручний спосіб зв'язку", contacts: { WhatsApp: "WhatsApp", Telefon: "Дзвінок", Email: "E-mail" },
      },
      review: {
        service: "Послуга", location: "Місце", appointment: "Бажаний час", contact: "Контакт", edit: "Змінити",
        consent: "Я погоджуюся на обробку моїх даних для опрацювання запиту.",
        primary: "Надіслати через WhatsApp", secondary: "Надіслати без WhatsApp",
        hint: "Запит буде збережено, а WhatsApp відкриється з підготовленим повідомленням. Будь ласка, натисніть там «Надіслати».",
        photosNote: "Фото передаються через форму й не прикріплюються до WhatsApp автоматично.",
      },
      nav: { back: "Назад", next: "Далі", saving: "Зберігаємо …" },
      errors: {
        service: "Будь ласка, оберіть послугу.", location: "Будь ласка, оберіть або введіть місце.",
        date: "Будь ласка, оберіть бажану дату.", name: "Будь ласка, введіть ім'я.",
        phone: "Будь ласка, введіть коректний номер телефону.", email: "Перевірте адресу e-mail.",
        emailRequired: "Для зв'язку e-mail потрібна ваша адреса.", consent: "Будь ласка, підтвердьте згоду.",
        submit: "Не вдалося надіслати. Спробуйте ще раз або напишіть нам у WhatsApp.",
        photos: "Максимум 5 фото.",
      },
      done: {
        titleWa: "Майже готово — надішліть у WhatsApp.",
        textWa: "Ваш запит збережено. WhatsApp відкрито з підготовленим повідомленням — воно буде доставлене лише після того, як ви натиснете «Надіслати».",
        titleForm: "Дякуємо — ваш запит отримано.",
        textForm: "Ми зв'яжемося з вами обраним способом.",
        reference: "Номер запиту", reopen: "Відкрити WhatsApp ще раз", newRequest: "Новий запит",
      },
      wa: {
        greeting: "Вітаю, PUREGLOSS! Я залишив(ла) запит на сайті:", service: "Послуга", location: "Місце",
        appointment: "Бажаний час", name: "Ім'я", phone: "Телефон", email: "E-mail", object: "Об'єкт", details: "Деталі",
        photos: (n) => `${n} фото завантажено через форму`, contact: "Зручний зв'язок", ref: "Номер",
      },
      liveSlots: "Бажаєте одразу обрати вільний час у календарі?", backToWizard: "Назад до запиту",
    },
    map: {
      eyebrow: "Зона виїзду", title: "Ми приїжджаємо до вас.",
      subtitle: "Преміум детейлінг авто та хімчистка меблів — мобільно, просто у вас.",
      base: "Наша база", core: "Основна зона", extended: "Розширена зона · за домовленістю",
      request: "Дізнатись ціну", list: "Усі міста списком", hideList: "Сховати список", loading: "Завантаження карти …",
      select: "Обрати місто",
    },
    area: {
      short: "Основна зона Euskirchen · Köln · Bonn з околицями. А також Düren та околиці. За домовленістю — Айфель, Düsseldorf/Neuss, Бергіше-Ланд і Рурська область.",
      footerTitle: "Усі міста виїзду", search: "Пошук міста", showAll: "Показати всі міста", hide: "Згорнути",
    },
    reviews: {
      title: "Що кажуть наші клієнти.", text: "Справжні відгуки з нашого профілю компанії в Google.",
      fallback: "Читайте незалежні відгуки наших клієнтів безпосередньо в Google.", cta: "Усі відгуки в Google",
      prev: "Попередній відгук", next: "Наступний відгук", source: "Відгуки з Google", count: "відгуків",
      original: "Переглянути в Google",
    },
    academyConcept: "Ілюстрація · створено ШІ",
  },
  en: {
    booking: {
      eyebrow: "Request & appointment", title: "Your service. Configured in a minute.",
      subtitle: "Choose the service, location and preferred time — we'll reply with a personal quote.",
      response: "We usually reply within 1 hour.",
      steps: ["Service", "Location", "Time", "Details", "Review"],
      stepTitles: ["Which service would you like?", "Where should we come to you?", "When suits you?", "How can we reach you?", "Your request at a glance"],
      services: {
        interior: { title: "Interior Detailing", desc: "Seats, carpets, plastics, glass" },
        exterior: { title: "Exterior Detailing", desc: "Hand wash, wheels, paint care" },
        complete: { title: "Complete Detailing", desc: "Inside and out in one visit" },
        sofa: { title: "Sofa & Upholstery Cleaning", desc: "Sofas, armchairs, mattresses at your home" },
        other: { title: "Other / Custom Request", desc: "Tell us what you need" },
      },
      location: {
        search: "Search a town …", core: "Core area", extended: "Extended area",
        extendedNote: "Appointments in the extended area by individual agreement.",
        other: "Another location", otherPlaceholder: "Enter town or postcode", noResults: "No match — enter your location below.",
      },
      appointment: {
        modes: {
          date: { title: "Preferred date", desc: "Pick a date and time window" },
          flexible: { title: "I'm flexible", desc: "We'll suggest options" },
          earliest: { title: "Earliest available", desc: "Next free appointment" },
        },
        windowLabel: "Preferred time window", anyTime: "Any time",
        windows: { "08-11": "Morning", "11-14": "Midday", "14-17": "Afternoon", "17-20": "Evening" },
        notice: "A requested date is not a confirmed appointment. We will confirm it with you personally.",
      },
      details: {
        name: "Name", phone: "Phone / WhatsApp", email: "Email", optional: "optional",
        vehicle: "Vehicle model", furniture: "Furniture type", object: "Item", objectPlaceholderCar: "e.g. BMW X5, 2021", objectPlaceholderSofa: "e.g. 3-seater sofa, fabric",
        notes: "Details", notesPlaceholder: "Condition, special wishes, parking …",
        photos: "Add photos", photosHint: "Optional, up to 5 images. Photos are transferred securely through our form.",
        contact: "Preferred contact", contacts: { WhatsApp: "WhatsApp", Telefon: "Phone call", Email: "Email" },
      },
      review: {
        service: "Service", location: "Location", appointment: "Preferred time", contact: "Contact", edit: "Edit",
        consent: "I agree to my details being processed to handle my request.",
        primary: "Send via WhatsApp", secondary: "Submit without WhatsApp",
        hint: "Your request is saved and WhatsApp opens with a prepared message. Please tap \u201cSend\u201d there.",
        photosNote: "Photos are submitted through the form and are not attached to WhatsApp automatically.",
      },
      nav: { back: "Back", next: "Continue", saving: "Saving …" },
      errors: {
        service: "Please choose a service.", location: "Please choose or enter a location.",
        date: "Please choose a preferred date.", name: "Please enter your name.",
        phone: "Please enter a valid phone number.", email: "Please check the email address.",
        emailRequired: "We need your email address to contact you by email.", consent: "Please confirm your consent.",
        submit: "Sending failed. Please try again or message us directly on WhatsApp.",
        photos: "Maximum 5 photos.",
      },
      done: {
        titleWa: "Almost done — please send it in WhatsApp.",
        textWa: "Your request is saved with us. WhatsApp has opened with a prepared message — it is only delivered once you tap \u201cSend\u201d there.",
        titleForm: "Thank you — your request has been received.",
        textForm: "We'll get back to you via your preferred channel.",
        reference: "Reference", reopen: "Open WhatsApp again", newRequest: "New request",
      },
      wa: {
        greeting: "Hello PUREGLOSS, I've submitted a request on your website:", service: "Service", location: "Location",
        appointment: "Preferred time", name: "Name", phone: "Phone", email: "Email", object: "Item", details: "Details",
        photos: (n) => `${n} photo(s) uploaded via the form`, contact: "Preferred contact", ref: "Reference",
      },
      liveSlots: "Prefer to pick a free slot in the calendar right away?", backToWizard: "Back to request",
    },
    map: {
      eyebrow: "Service area", title: "We come to you.",
      subtitle: "Premium car detailing and upholstery cleaning — mobile, right at your location.",
      base: "Our base", core: "Core area", extended: "Extended area · by agreement",
      request: "Request a price", list: "All locations as a list", hideList: "Hide list", loading: "Loading map …",
      select: "Select location",
    },
    area: {
      short: "Core area Euskirchen · Cologne · Bonn and surroundings. Plus Düren and surroundings. By agreement also the Eifel, Düsseldorf/Neuss, the Bergisches Land and the Ruhr area.",
      footerTitle: "All service locations", search: "Search a town", showAll: "Show all locations", hide: "Show less",
    },
    reviews: {
      title: "What our customers say.", text: "Genuine reviews from our Google Business Profile.",
      fallback: "Read independent reviews from our customers directly on Google.", cta: "All reviews on Google",
      prev: "Previous review", next: "Next review", source: "Reviews from Google", count: "reviews",
      original: "View on Google",
    },
    academyConcept: "Concept image · AI-generated",
  },
  pl: {
    booking: {
      eyebrow: "Zapytanie i termin", title: "Twoja usługa. Skonfigurowana w minutę.",
      subtitle: "Wybierz usługę, miejsce i preferowany termin — odpowiemy z indywidualną ofertą.",
      response: "Zazwyczaj odpowiadamy w ciągu 1 godziny.",
      steps: ["Usługa", "Miejsce", "Termin", "Dane", "Podsumowanie"],
      stepTitles: ["Jakiej usługi potrzebujesz?", "Dokąd mamy przyjechać?", "Kiedy Ci pasuje?", "Jak możemy się skontaktować?", "Twoje zapytanie w skrócie"],
      services: {
        interior: { title: "Detailing wnętrza", desc: "Fotele, dywaniki, plastiki, szyby" },
        exterior: { title: "Detailing nadwozia", desc: "Mycie ręczne, felgi, pielęgnacja lakieru" },
        complete: { title: "Kompleksowy detailing", desc: "Wnętrze i nadwozie podczas jednej wizyty" },
        sofa: { title: "Pranie kanap i tapicerki", desc: "Kanapy, fotele, materace u Ciebie w domu" },
        other: { title: "Inne / indywidualne zapytanie", desc: "Opisz, czego potrzebujesz" },
      },
      location: {
        search: "Szukaj miejscowości …", core: "Obszar główny", extended: "Obszar rozszerzony",
        extendedNote: "Terminy w obszarze rozszerzonym po indywidualnym uzgodnieniu.",
        other: "Inna miejscowość", otherPlaceholder: "Wpisz miejscowość lub kod pocztowy", noResults: "Nie znaleziono — wpisz miejscowość poniżej.",
      },
      appointment: {
        modes: {
          date: { title: "Preferowana data", desc: "Wybierz datę i przedział czasu" },
          flexible: { title: "Jestem elastyczny", desc: "Zaproponujemy terminy" },
          earliest: { title: "Najszybciej jak się da", desc: "Najbliższy wolny termin" },
        },
        windowLabel: "Preferowany przedział", anyTime: "Dowolnie",
        windows: { "08-11": "Rano", "11-14": "W południe", "14-17": "Po południu", "17-20": "Wieczorem" },
        notice: "Preferowany termin nie jest jeszcze potwierdzoną wizytą. Potwierdzimy go z Tobą osobiście.",
      },
      details: {
        name: "Imię i nazwisko", phone: "Telefon / WhatsApp", email: "E-mail", optional: "opcjonalnie",
        vehicle: "Model samochodu", furniture: "Rodzaj mebla", object: "Przedmiot", objectPlaceholderCar: "np. BMW X5, 2021", objectPlaceholderSofa: "np. kanapa 3-osobowa, tkanina",
        notes: "Szczegóły", notesPlaceholder: "Stan, życzenia, możliwość parkowania …",
        photos: "Dodaj zdjęcia", photosHint: "Opcjonalnie, do 5 zdjęć. Zdjęcia są bezpiecznie przesyłane przez nasz formularz.",
        contact: "Preferowany kontakt", contacts: { WhatsApp: "WhatsApp", Telefon: "Telefon", Email: "E-mail" },
      },
      review: {
        service: "Usługa", location: "Miejsce", appointment: "Preferowany termin", contact: "Kontakt", edit: "Zmień",
        consent: "Wyrażam zgodę na przetwarzanie moich danych w celu obsługi zapytania.",
        primary: "Wyślij przez WhatsApp", secondary: "Wyślij bez WhatsApp",
        hint: "Zapytanie zostanie zapisane, a WhatsApp otworzy się z przygotowaną wiadomością. Kliknij tam „Wyślij”.",
        photosNote: "Zdjęcia są przesyłane przez formularz i nie są automatycznie dołączane do WhatsApp.",
      },
      nav: { back: "Wstecz", next: "Dalej", saving: "Zapisywanie …" },
      errors: {
        service: "Wybierz usługę.", location: "Wybierz lub wpisz miejscowość.",
        date: "Wybierz preferowaną datę.", name: "Podaj imię i nazwisko.",
        phone: "Podaj prawidłowy numer telefonu.", email: "Sprawdź adres e-mail.",
        emailRequired: "Do kontaktu e-mailowego potrzebujemy Twojego adresu.", consent: "Potwierdź zgodę.",
        submit: "Wysyłanie nie powiodło się. Spróbuj ponownie lub napisz do nas na WhatsApp.",
        photos: "Maksymalnie 5 zdjęć.",
      },
      done: {
        titleWa: "Prawie gotowe — wyślij wiadomość w WhatsApp.",
        textWa: "Twoje zapytanie zostało zapisane. WhatsApp otworzył się z przygotowaną wiadomością — zostanie dostarczona dopiero po kliknięciu „Wyślij”.",
        titleForm: "Dziękujemy — otrzymaliśmy Twoje zapytanie.",
        textForm: "Skontaktujemy się z Tobą wybranym kanałem.",
        reference: "Numer", reopen: "Otwórz WhatsApp ponownie", newRequest: "Nowe zapytanie",
      },
      wa: {
        greeting: "Dzień dobry PUREGLOSS, wysłałem(-am) zapytanie przez stronę:", service: "Usługa", location: "Miejsce",
        appointment: "Preferowany termin", name: "Imię", phone: "Telefon", email: "E-mail", object: "Przedmiot", details: "Szczegóły",
        photos: (n) => `${n} zdjęć przesłano przez formularz`, contact: "Preferowany kontakt", ref: "Numer",
      },
      liveSlots: "Wolisz od razu wybrać wolny termin w kalendarzu?", backToWizard: "Wróć do zapytania",
    },
    map: {
      eyebrow: "Obszar działania", title: "Przyjeżdżamy do Ciebie.",
      subtitle: "Premium detailing samochodów i pranie tapicerki — mobilnie, u Ciebie na miejscu.",
      base: "Nasza baza", core: "Obszar główny", extended: "Obszar rozszerzony · po uzgodnieniu",
      request: "Zapytaj o cenę", list: "Wszystkie miejscowości jako lista", hideList: "Ukryj listę", loading: "Ładowanie mapy …",
      select: "Wybierz miejscowość",
    },
    area: {
      short: "Obszar główny Euskirchen · Kolonia · Bonn i okolice. Także Düren i okolice. Po uzgodnieniu również Eifel, Düsseldorf/Neuss, Bergisches Land i Zagłębie Ruhry.",
      footerTitle: "Wszystkie miejscowości", search: "Szukaj miejscowości", showAll: "Pokaż wszystkie", hide: "Pokaż mniej",
    },
    reviews: {
      title: "Co mówią nasi klienci.", text: "Prawdziwe opinie z naszego profilu firmy w Google.",
      fallback: "Przeczytaj niezależne opinie naszych klientów bezpośrednio w Google.", cta: "Wszystkie opinie w Google",
      prev: "Poprzednia opinia", next: "Następna opinia", source: "Opinie z Google", count: "opinii",
      original: "Zobacz w Google",
    },
    academyConcept: "Zdjęcie poglądowe · wygenerowane przez AI",
  },
  ru: {
    booking: {
      eyebrow: "Запрос и запись", title: "Ваш сервис. Настроен за минуту.",
      subtitle: "Выберите услугу, место и желаемое время — мы пришлём персональное предложение.",
      response: "Обычно мы отвечаем в течение 1 часа.",
      steps: ["Услуга", "Место", "Время", "Данные", "Проверка"],
      stepTitles: ["Какая услуга вас интересует?", "Куда нам приехать?", "Когда вам удобно?", "Как с вами связаться?", "Ваш запрос кратко"],
      services: {
        interior: { title: "Химчистка салона", desc: "Сиденья, коврики, пластик, стёкла" },
        exterior: { title: "Уход за кузовом", desc: "Ручная мойка, диски, уход за лаком" },
        complete: { title: "Комплексный детейлинг", desc: "Салон и кузов за один визит" },
        sofa: { title: "Химчистка диванов и мебели", desc: "Диваны, кресла, матрасы у вас дома" },
        other: { title: "Другое / индивидуальный запрос", desc: "Опишите, что вам нужно" },
      },
      location: {
        search: "Поиск города …", core: "Основная зона", extended: "Расширенная зона",
        extendedNote: "Выезд в расширенную зону — по индивидуальной договорённости.",
        other: "Другое место", otherPlaceholder: "Город или почтовый индекс", noResults: "Город не найден — введите его ниже вручную.",
      },
      appointment: {
        modes: {
          date: { title: "Желаемая дата", desc: "Выберите дату и интервал" },
          flexible: { title: "Я гибок", desc: "Мы предложим варианты" },
          earliest: { title: "Как можно скорее", desc: "Ближайшее свободное время" },
        },
        windowLabel: "Желаемый интервал", anyTime: "Любое время",
        windows: { "08-11": "Утро", "11-14": "Полдень", "14-17": "День", "17-20": "Вечер" },
        notice: "Желаемое время ещё не является подтверждённой записью. Мы подтвердим его лично.",
      },
      details: {
        name: "Имя", phone: "Телефон / WhatsApp", email: "E-mail", optional: "необязательно",
        vehicle: "Модель автомобиля", furniture: "Тип мебели", object: "Объект", objectPlaceholderCar: "напр. BMW X5, 2021", objectPlaceholderSofa: "напр. 3-местный диван, ткань",
        notes: "Детали", notesPlaceholder: "Состояние, пожелания, парковка …",
        photos: "Добавить фото", photosHint: "Необязательно, до 5 фото. Фото безопасно передаются через нашу форму.",
        contact: "Удобный способ связи", contacts: { WhatsApp: "WhatsApp", Telefon: "Звонок", Email: "E-mail" },
      },
      review: {
        service: "Услуга", location: "Место", appointment: "Желаемое время", contact: "Контакт", edit: "Изменить",
        consent: "Я согласен(на) на обработку моих данных для обработки запроса.",
        primary: "Отправить через WhatsApp", secondary: "Отправить без WhatsApp",
        hint: "Запрос будет сохранён, а WhatsApp откроется с подготовленным сообщением. Пожалуйста, нажмите там «Отправить».",
        photosNote: "Фото передаются через форму и не прикрепляются к WhatsApp автоматически.",
      },
      nav: { back: "Назад", next: "Далее", saving: "Сохраняем …" },
      errors: {
        service: "Пожалуйста, выберите услугу.", location: "Пожалуйста, выберите или введите место.",
        date: "Пожалуйста, выберите желаемую дату.", name: "Пожалуйста, введите имя.",
        phone: "Пожалуйста, введите корректный номер телефона.", email: "Проверьте адрес e-mail.",
        emailRequired: "Для связи по e-mail нужен ваш адрес.", consent: "Пожалуйста, подтвердите согласие.",
        submit: "Не удалось отправить. Попробуйте ещё раз или напишите нам в WhatsApp.",
        photos: "Максимум 5 фото.",
      },
      done: {
        titleWa: "Почти готово — отправьте в WhatsApp.",
        textWa: "Ваш запрос сохранён. WhatsApp открыт с подготовленным сообщением — оно будет доставлено только после нажатия «Отправить».",
        titleForm: "Спасибо — ваш запрос получен.",
        textForm: "Мы свяжемся с вами выбранным способом.",
        reference: "Номер запроса", reopen: "Открыть WhatsApp снова", newRequest: "Новый запрос",
      },
      wa: {
        greeting: "Здравствуйте, PUREGLOSS! Я оставил(а) запрос на сайте:", service: "Услуга", location: "Место",
        appointment: "Желаемое время", name: "Имя", phone: "Телефон", email: "E-mail", object: "Объект", details: "Детали",
        photos: (n) => `${n} фото загружено через форму`, contact: "Удобная связь", ref: "Номер",
      },
      liveSlots: "Хотите сразу выбрать свободное время в календаре?", backToWizard: "Назад к запросу",
    },
    map: {
      eyebrow: "Зона выезда", title: "Мы приезжаем к вам.",
      subtitle: "Премиум детейлинг автомобилей и химчистка мебели — мобильно, прямо у вас.",
      base: "Наша база", core: "Основная зона", extended: "Расширенная зона · по договорённости",
      request: "Узнать цену", list: "Все города списком", hideList: "Скрыть список", loading: "Загрузка карты …",
      select: "Выбрать город",
    },
    area: {
      short: "Основная зона Euskirchen · Köln · Bonn с окрестностями. А также Düren и окрестности. По договорённости — Айфель, Düsseldorf/Neuss, Бергишес-Ланд и Рурская область.",
      footerTitle: "Все города выезда", search: "Поиск города", showAll: "Показать все города", hide: "Свернуть",
    },
    reviews: {
      title: "Что говорят наши клиенты.", text: "Настоящие отзывы из нашего профиля компании в Google.",
      fallback: "Читайте независимые отзывы наших клиентов прямо в Google.", cta: "Все отзывы в Google",
      prev: "Предыдущий отзыв", next: "Следующий отзыв", source: "Отзывы из Google", count: "отзывов",
      original: "Открыть в Google",
    },
    academyConcept: "Иллюстрация · создано ИИ",
  },
};

export const p22Copy = (lang) => COPY[lang] || COPY.de;
